import {
	Button,
	ButtonGroup,
	DropdownFormInput,
} from "@ruter-as/web-components-and-tools";
import type React from "react";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import type { CompanyWithAvailableSubscriptions } from "../../types/Company";

interface SelectCompanyFormData {
	companyId: string;
}

interface Props {
	companies: CompanyWithAvailableSubscriptions[];
	onSubmit: (company: CompanyWithAvailableSubscriptions) => Promise<void>;
}

const SelectCompanyForm: React.FC<Props> = ({ companies, onSubmit }) => {
	const formMethods = useForm<SelectCompanyFormData>();
	const [loading, setLoading] = useState(false);

	const submitCompany = async (data: SelectCompanyFormData) => {
		setLoading(true);
		const company = companies.find((x) => x.id === data.companyId);

		if (!company) {
			throw new Error("company can not be empty");
		}

		await onSubmit(company);
	};

	useEffect(() => {
		document.getElementById("companyId")?.focus();
	}, []);

	const options = [
		{
			value: "",
			text: "",
		},
		...companies.map((c) => ({ value: c.id, text: c.name })),
	];

	return (
		<FormProvider {...formMethods}>
			<form
				style={{ marginTop: "1rem" }}
				onSubmit={formMethods.handleSubmit(submitCompany)}
				data-test-id="select-company-form"
			>
				<DropdownFormInput
					name="companyId"
					label="Velg ditt selskap"
					validationLabel="Selskap"
					required
				>
					{options.map((o) => (
						<option value={o.value} key={o.value}>
							{o.text}
						</option>
					))}
				</DropdownFormInput>
				<ButtonGroup>
					<Button type="submit" skin="primary" loading={loading}>
						Bekreft
					</Button>
				</ButtonGroup>
			</form>
		</FormProvider>
	);
};

export default SelectCompanyForm;
